<template>
  <div class="nav-search">
    <button
      ref="toggle"
      class="nav-search__toggle"
      :class="{ active: searchActive }"
      aria-label="Expand search"
      aria-haspopup="true"
      :aria-expanded="searchActive"
      @click.prevent="toggleSearch"
      @keydown.esc.prevent="toggleSearch"
    >
      <span>Expand search</span>
    </button>
    <lms-nav-slide transition="primaryFade">
      <div
        ref="drawer"
        v-show="searchActive"
        @keydown.esc.prevent="toggleSearch"
        class="nav__drawer nav-search__drawer"
      >
        <div class="row nav__columns justify-content-center">
          <div class="col">
            <lms-search></lms-search>
          </div>
        </div>
      </div>
    </lms-nav-slide>
  </div>
</template>

<script lang="js">
  import { mapState } from 'vuex';
  import lmsNavSlide from "../navigation/nav-slide.vue";
  import lmsSearch from "../search/search.vue";

  export default  {
    name: 'lms-nav-search',
    components: {
		lmsNavSlide,
	  lmsSearch
    },
    data() {
      return {
		searchActive: false
      }
    },
    computed: mapState(['searchOpen', 'navOpen']),
	watch: {
      navOpen(newValue) {
        if(newValue) {
          this.resetSearch();
        }
      },
      searchOpen(newValue) {
        if(!newValue) {
          this.resetSearch();
        }
      }
	},
    mounted () {
		this.moveDrawer();
    },
    methods: {
      /**
	   * Relocate the drawer to just below primary nav
       */
      moveDrawer() {
        const primaryNav = document.querySelector('.nav__primary');
        primaryNav.append(this.$refs.drawer);
	  },
      /**
	   * Open and close search drawer
       */
      toggleSearch() {
        this.searchActive = !this.searchActive;
        this.$store.state.searchOpen = this.searchActive;
        if(!this.searchActive) {
		this.$refs.toggle.focus();
		}
      },
	  resetSearch() {
        this.searchActive = false;
        this.$store.state.searchOpen = false;
	  }
    },
}
</script>

<style lang="scss"></style>
